import { render, staticRenderFns } from "./index.vue?vue&type=template&id=330b6e96"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=330b6e96&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBreadcrumbs: require('/builds/project/wyffest/frontend/components/app/AppBreadcrumbs.vue').default,AppSpinner: require('/builds/project/wyffest/frontend/components/app/AppSpinner.vue').default,AppEmpty: require('/builds/project/wyffest/frontend/components/app/AppEmpty.vue').default,PhotoEvent: require('/builds/project/wyffest/frontend/components/photo/PhotoEvent.vue').default,AppPagination: require('/builds/project/wyffest/frontend/components/app/AppPagination.vue').default})
